import {useState} from "react";
import {PublicInfo} from "./PublicInfo";
import {NotificationSettings} from "./NotificationSettings";
import {EmailSubscriptions} from "./EmailSubscriptions";
import {blockObjectFactory} from "../../components/blocks/SchoolBlocks/blockUtils";

export const enum settingsView {
    "myPublicInfo",
    "notificationSettings",
    "subscriptions",
}

export interface IUserWithSubscriptions extends Omit<IUser, "push_subscriptions"> {
    push_subscriptions: PushSubscription[]
}

export interface IPersonBlockWithPushSubscriptions extends Omit<IPersonBlock, "blockModel"> {
    blockModel: IUserWithSubscriptions
}

export default function UserSettingsPage(props: {
    user: IUserWithSubscriptions
}) {
    const [currentView, setCurrentView] = useState<settingsView>(settingsView.myPublicInfo);

    const [notificationSettings, setNotificationSettings] = useState({});
    const [userObject] = useState<IPersonBlockWithPushSubscriptions>(blockObjectFactory("person", {blockModel: props.user}) as IPersonBlockWithPushSubscriptions);

    let content;
    if (currentView === settingsView.myPublicInfo) {
        content = <PublicInfo userObj={userObject} />
    } else if (currentView === settingsView.notificationSettings) {
        content = <NotificationSettings
            notificationSettings={notificationSettings}
            setNotificationSettings={setNotificationSettings}
            userObj={userObject}
            setCurrentView={setCurrentView}
        />
    } else if (currentView === settingsView.subscriptions) {
        content = <EmailSubscriptions userObj={userObject} />
    }

    return <div className={"sb-settings-container"}>
        <div className="sb-settings-block-bootstrap">
            <div className="col-sm-2 sb-settings-block-navigation">
                <ul className="nav admin-nav nav-pills nav-stacked" role="tablist">
                    <li role="presentation"
                        className={`nav-li ${currentView === settingsView.myPublicInfo ? "active" : ""}`}>
                        <a href={"#"} onClick={() => setCurrentView(settingsView.myPublicInfo)}
                           aria-controls="profile" role="tab">My Public Information</a>
                    </li>
                    {process.env.BETA_FEATURES_ENABLED && <li role="presentation"
                        className={`nav-li ${currentView === settingsView.notificationSettings ? "active" : ""}`}>
                        <a href={"#"} onClick={() => setCurrentView(settingsView.notificationSettings)} role="tab">Notification
                            Settings</a>
                    </li>}
                    <li role="presentation"
                        className={`nav-li ${currentView === settingsView.subscriptions ? "active" : ""}`}>
                        <a href={"#"} onClick={() => setCurrentView(settingsView.subscriptions)}
                           aria-controls="profile" role="tab">Mailing Lists</a>
                    </li>
                </ul>
            </div>
            <div id="user-settings-content" className="col-sm-10 sb-settings-block-content">
                {content}
            </div>
        </div>
    </div>
}
